import axios from "axios";
import config from "../../config";
import { saveAs } from "file-saver";

const baseUrl = config.baseUrl;
const endpoint1 = "/api/headerDetallePO";

const endpoint2 = "/api/poaPO";
const endpoint3 = "/api/update-avancePO";
const endpoint4 = "/api/actualizar-fechaPO";
const endpoint5 = "/api/actualizar-pesotareaPO";
const endpoint6 = "/api/poaPOPeso";
const endpoint7 = "/api/poaPOExp";
const endpoint8 = "/api/poaPOPesoResumen";
const endpoint9 = "/api/poaPOPesoResumenCompleto";
const endpoint10 = "/api/poaPOExpAll";

const endpoint11 = "/api/poReportarAvance";
const endpoint12 = "/api/poActualizarAvance";
const endpoint13 = "/api/poAvancesIndividuales";
const endpoint14 = "/api/poIndiceAvances";
const endpoint15 = "/api/downloadAllSoportes";
const endpoint16 = "/api/deleteAvanceIndividual";

const getHeader = async (oid_proyecto) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint1}?oid_proyecto=${oid_proyecto}`
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    if (error.response?.status === 404) {
      console.error("El proyecto no existe o no se encontró información.");
    } else {
      console.error("Error al obtener los proyectos:", error);
    }
    throw error;
  }
};

const getPOA = async (fase_id, oid_proyecto) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint2}?fase_id=${fase_id}&oid_proyecto=${oid_proyecto}`
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al obtener las actividades:", error);
    throw error;
  }
};

const getPOPeso = async (fase_id, oid_proyecto, modo) => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint6}`, {
      fase_id,
      oid_proyecto,
      modo,
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al obtener las actividades:", error);
    throw error;
  }
};

const getPOPesoResumen = async () => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint8}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al obtener las resumen:", error);
    throw error;
  }
};

const getPOAll = async () => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint10}`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las resumen:", error);
    throw error;
  }
};

// ahora devuelve directamente lo que venga en response.data
const getPOPesoResumenCompleto = async (oidProyecto) => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint9}`, {
      oidProyecto,
    });
    // response.data es { status: 200, success: true, data: { proyecto, detalle } }
    return response.data;
  } catch (error) {
    console.error("Error al obtener el resumen completo:", error);
    throw error;
  }
};

const getPOAExport = async (oid_proyecto) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint7}?oid_proyecto=${oid_proyecto}`
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al obtener las actividades:", error);
    throw error;
  }
};

const updateAvance = async (id, avance) => {
  try {
    const response = await axios.put(`${baseUrl}${endpoint3}`, { id, avance });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al actualizar el avance:", error);
    throw error;
  }
};

const eliminarAvanceService = async (id, filePath, oidIndicador) => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint16}`, {
      id,
      filePath,
      oidIndicador,
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("❌ Error al eliminar el avance:", error);

    // Respuesta controlada
    if (error.response) {
      return {
        status: error.response.status,
        data: error.response.data,
      };
    }

    throw error; // fallback
  }
};

//Actualizar peso porcentual
const updatePeso = async (id, avance) => {
  try {
    const response = await axios.put(`${baseUrl}${endpoint5}`, { id, avance });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al actualizar el avance:", error);
    throw error;
  }
};

const updateFecha = async (oid, fecha, tipo) => {
  try {
    const response = await axios.put(`${baseUrl}${endpoint4}`, {
      oid,
      fecha,
      tipo,
    });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al actualizar la fecha:", error);
    throw error;
  }
};

const reportarAvance = async (formData) => {
  try {
    const response = await axios.post(`${baseUrl}${endpoint11}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al reportar avance:", error);
    // Reenvía el error para que tu UI lo capture
    throw error;
  }
};

//Actualizar de Avance
const updateAvanceIndividual = async (id, avance) => {
  try {
    const response = await axios.put(`${baseUrl}${endpoint12}`, { id, avance });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al actualizar el avance:", error);
    throw error;
  }
};

/**
 * Consulta el histórico de avances.
 * Si el servidor responde 404 (no hay datos), devolvemos un objeto con data: { data: [] }
 * y un status 404, para que el consumidor lo trate como “lista vacía”.
 */
const getPOAvancesIndividuales = async (oidIndicador, mesano) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint13}?oidIndicador=${oidIndicador}&mesano=${mesano}`
    );

    return {
      status: response.status,
      data: response.data, // aquí response.data = { status:200, success:true, data: [...] }
    };
  } catch (error) {
    // Si el servidor devolvió 404, interpretamos “sin registros”:
    if (error.response && error.response.status === 404) {
      return {
        status: 404,
        data: {
          status: 404,
          success: false,
          message: "No se encontraron registros.",
          data: [], // devolvemos array vacío
        },
      };
    }
    console.warn("No se tienen avances individuales:", error);
    throw error;
  }
};

const getPOAInidceAvancesIndividuales = async (oidIndicador) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint14}?oidIndicador=${oidIndicador}`
    );
    return {
      data: response.data, // aquí response.data = { status:200, success:true, data: [...] }
    };
  } catch (error) {
    // Si el servidor devolvió 404, interpretamos “sin registros”:
    if (error.response && error.response.status === 404) {
      return {
        status: 404,
        data: {
          status: 404,
          success: false,
          message: "No se encontraron registros.",
          data: [], // devolvemos array vacío
        },
      };
    }
    console.warn("No se tienen avances individuales:", error);
    throw error;
  }
};

const descargaSoportes = async (proyecto, indicadorId) => {
  try {
    // Llamada GET con responseType 'blob' para obtener el ZIP
    const response = await axios.get(`${baseUrl}${endpoint15}`, {
      params: { proyecto, indicadorId },
      responseType: "blob",
    });

    // Construimos nombre de archivo para descarga
    const fileName = `${proyecto}_${indicadorId}_soportes.zip`;

    // Utilizamos file-saver para disparar la descarga en el navegador
    saveAs(response.data, fileName);
  } catch (error) {
    console.error("Error descargando soportes:", error);
    throw error;
  }
};

export {
  getHeader,
  getPOA,
  updateAvance,
  updateFecha,
  updatePeso,
  getPOPeso,
  getPOAExport,
  getPOPesoResumen,
  getPOPesoResumenCompleto,
  getPOAll,
  reportarAvance,
  updateAvanceIndividual,
  getPOAvancesIndividuales,
  getPOAInidceAvancesIndividuales,
  descargaSoportes,
  eliminarAvanceService,
};
